/**
 * Reserved top-of-feed skeleton for Phone Risk Summary (CLS guard).
 *
 * @param {{ className?: string }} props
 */
export default function PhoneMetadataSkeleton({ className = '' }) {
  return (
    <div
      className={`feed-skeleton-card min-h-[9.5rem] overflow-hidden rounded-[1.5rem] border border-cyan-500/20 bg-slate-800/50 p-4 backdrop-blur-md sm:p-5 ${className}`.trim()}
      aria-busy="true"
      aria-label="Loading phone metadata"
      data-testid="phone-metadata-skeleton"
    >
      <section className="flex gap-4">
        <span className="feed-skeleton-block h-14 w-14 shrink-0 rounded-2xl" aria-hidden />
        <span className="min-w-0 flex-1 space-y-2.5">
          <span className="feed-skeleton-block block h-2.5 w-28 rounded" aria-hidden />
          <span className="feed-skeleton-block block h-5 w-[55%] max-w-sm rounded" aria-hidden />
          <span className="flex flex-wrap gap-1.5 pt-1">
            <span className="feed-skeleton-block h-5 w-24 rounded-md" aria-hidden />
            <span className="feed-skeleton-block h-5 w-32 rounded-md" aria-hidden />
            <span className="feed-skeleton-block h-5 w-28 rounded-md" aria-hidden />
            <span className="feed-skeleton-block h-5 w-20 rounded-md" aria-hidden />
          </span>
        </span>
      </section>
      <span className="feed-skeleton-block mt-4 block h-8 w-40 rounded-lg" aria-hidden />
    </div>
  );
}
